import clsx from "clsx";
import Select from "./Select";
import s from "./styles.module.sass";

export type Tab = {
	id: number;
	title: string;
};

type TabsProps = {
	activeTab: number;
	tabs: Tab[];
	disabled?: boolean;
	onSelect: (id: number) => void;
};

const Tabs = ({ activeTab, tabs, disabled, onSelect }: TabsProps) => {
	const renderTabs = () => {
		return tabs.map((tab: Tab) => {
			return (
				<button
					key={tab.id}
					disabled={disabled}
					className={clsx(s.tab, {
						[s.active]: activeTab === tab.id,
						[s.disabled]: disabled,
					})}
					onClick={() => {
						return onSelect(tab.id);
					}}
				>
					{tab.title}
				</button>
			);
		});
	};

	return (
		<>
			<div className={s.tabs}>{renderTabs()}</div>
			<div className={s.select}>
				<Select
					// disabled={disabled}
					selectedOption={activeTab}
					options={tabs}
					onSelect={onSelect}
				/>
			</div>
		</>
	);
};

export default Tabs;
